export const handleDownload = async (originUrl: string, title: string) => {
  if (!originUrl) return;

  // Fetch the image as a blob
  const response = await fetch(originUrl);
  const blob = await response.blob();

  // Create a blob URL
  const blobUrl = window.URL.createObjectURL(blob);

  // Extract file extension from URL
  const urlParts = originUrl.split('.');
  const extension = urlParts.length > 1 ? urlParts[urlParts.length - 1].split('?')[0] : 'jpg';

  // Create filename with title and extension
  const baseName = title || 'download';
  const filename = `${baseName}.${extension}`;

  // Create download link
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;

  // Trigger download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up blob URL
  window.URL.revokeObjectURL(blobUrl);
}